import { __decorate } from "tslib";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { action } from 'mobx';
import KeyCode from '../../../lib/_util/KeyCode';
import { getConfig } from '../../../lib/configure';
import pick from 'lodash/pick';
import Table from '../table/Table';
import TableProfessionalBar from '../table/query-bar/TableProfessionalBar';
import { SelectionMode, TableMode, TableQueryBarType } from '../table/enum';
import { DataSetSelection } from '../data-set/enum';
export default class LovView extends Component {
    constructor() {
        super(...arguments);
        /* istanbul ignore next */
        this.handleKeyDown = e => {
            if (e.keyCode === KeyCode.ENTER) {
                const { onEnterDown } = this.props;
                onEnterDown();
            }
        };
        /**
         * 单选 onRow 处理
         * @param props
         */
        this.handleRow = (props) => {
            const { onDoubleClick, tableProps } = this.props;
            let tablePropsOnRow;
            if (tableProps?.onRow)
                tablePropsOnRow = tableProps.onRow(props);
            return {
                onDoubleClick,
                ...tablePropsOnRow,
            };
        };
    }
    componentWillMount() {
        const { dataSet, dataSet: { selection }, multiple, } = this.props;
        this.selection = selection;
        dataSet.selection = multiple ? DataSetSelection.multiple : DataSetSelection.single;
    }
    componentWillUnmount() {
        const { dataSet } = this.props;
        dataSet.selection = this.selection;
    }
    /* istanbul ignore next */
    getColumns() {
        const { config: { lovItems }, tableProps, } = this.props;
        return lovItems
            ? lovItems
                .filter(({ gridField }) => gridField === 'Y')
                .sort(({ gridFieldSequence: seq1 }, { gridFieldSequence: seq2 }) => seq1 - seq2)
                .map(({ display, gridFieldName, gridFieldWidth, gridFieldAlign }) => {
                let column = {};
                if (tableProps && tableProps.columns) {
                    column = tableProps.columns.find(c => c.name === gridFieldName);
                }
                return {
                    ...column,
                    key: gridFieldName,
                    header: display,
                    name: gridFieldName,
                    width: gridFieldWidth,
                    align: gridFieldAlign,
                    editor: false,
                };
            })
            : undefined;
    }
    getQueryBar() {
        const { config: { queryBar }, tableProps, } = this.props;
        if (queryBar) {
            return queryBar;
        }
        if (tableProps && tableProps.queryBar) {
            return tableProps.queryBar;
        }
    }
    ;
    render() {
        const { dataSet, config: { height, treeFlag, queryColumns, tableProps: configTableProps }, multiple, tableProps, } = this.props;
        const lovTableProps = {
            customizable: getConfig('lovTableCustomizable'),
            autoFocus: true,
            mode: treeFlag === 'Y' ? TableMode.tree : TableMode.list,
            onKeyDown: this.handleKeyDown,
            dataSet,
            columns: this.getColumns(),
            queryFieldsLimit: queryColumns,
            queryBar: this.getQueryBar(),
            ...configTableProps,
            ...tableProps,
        };
        if (multiple) {
            lovTableProps.selectionMode = SelectionMode.rowbox;
        }
        else {
            lovTableProps.selectionMode = tableProps?.selectionMode ? tableProps.selectionMode : SelectionMode.none;
            lovTableProps.onRow = this.handleRow;
        }
        if (height) {
            lovTableProps.style = { ...lovTableProps.style, height };
        }
        const isProfessionalBar = getConfig('queryBar') === TableQueryBarType.professionalBar;
        if (!lovTableProps.queryBar && isProfessionalBar) {
            lovTableProps.queryBar = (props) => React.createElement(TableProfessionalBar, Object.assign({}, props, { queryBarProps: { labelWidth: 80 } }));
        }
        // 优化优先级 让 部分tableProps属性 的优先级大于dataSet的设置
        // 目前需要处理 selectionMode
        Object.assign(lovTableProps, pick({ ...tableProps }, [
            'selectionMode',
        ]));
        return React.createElement(Table, Object.assign({}, lovTableProps));
    }
}
LovView.propTypes = {
    dataSet: PropTypes.object.isRequired,
    config: PropTypes.object.isRequired,
    tableProps: PropTypes.object,
    onDoubleClick: PropTypes.func.isRequired,
    onEnterDown: PropTypes.func.isRequired,
};
__decorate([
    action
], LovView.prototype, "componentWillMount", null);
__decorate([
    action
], LovView.prototype, "componentWillUnmount", null);
